import React from 'react';
import {connect} from 'react-redux';
import {defineMessages, FormattedMessage} from 'react-intl';

import * as Languages from 'constants/Language';

const languageNameMap = {
    [Languages.RU]: 'Русский',
    [Languages.EN]: 'English',
    [Languages.UZ]: 'O\'zbek',
    [Languages.KK]: 'Қазақша',
};

const languageClassMap = {
    [Languages.RU]: 'ru',
    [Languages.EN]: 'en',
    [Languages.UZ]: 'uz',
    [Languages.KK]: 'kk',
};

const messages = defineMessages({
    localeChoose: {
        id: 'header.locale.choose',
        defaultMessage: 'Выбор языка:'
    }
});

class Locale extends React.Component {
    static propTypes = {
        languageId: React.PropTypes.number.isRequired,
        onLocaleChange: React.PropTypes.func.isRequired
    };

    constructor(props) {
        super(props);

        this.state = {showMenu: false};

        this._onDocumentClick = this._onDocumentClick.bind(this);
        this._onShowMenuClick = this._onShowMenuClick.bind(this);
    }

    shouldComponentUpdate(nextProps, nextState) {
        return this.props.languageId !== nextProps.languageId ||
            this.state.showMenu !== nextState.showMenu;
    }

    componentDidUpdate() {
        if (this.state.showMenu) {
            document.addEventListener('click', this._onDocumentClick);
        }
    }

    componentWillUnmount() {
        document.removeEventListener('click', this._onDocumentClick);
    }

    _onLangClick = (id) => (e) => {
        e.preventDefault();
        this.props.onLocaleChange(id);
    }

    _onDocumentClick() {
        document.removeEventListener('click', this._onDocumentClick);

        this.setState({
            showMenu: false
        });
    }

    _onShowMenuClick(e) {
        e.preventDefault();

        this.setState({
            showMenu: true
        });
    }

    render() {
        const { languageId, countryCode } = this.props;
        const languageName = languageNameMap[languageId];
        const currentLangClass = languageClassMap[languageId];

        const ruSelectLangClass = 'lang' + (languageId === Languages.RU ? ' selected' : '');
        const enSelectLangClass = 'lang' + (languageId === Languages.EN ? ' selected' : '');
        const uzSelectLangClass = 'lang' + (languageId === Languages.UZ ? ' selected' : '');
        const kkSelectLangClass = 'lang' + (languageId === Languages.KK ? ' selected' : '');

        const dropdownCls = 'dropdown' + (this.state.showMenu ? ' shown' : '');

        return (
            <div className="language pull-right">
                <a href="#" className="language-choose" onClick={this._onShowMenuClick}>
                    <span className="language-toggle"/>
                    <span className={currentLangClass}>{languageName}</span>
                </a>
                <ul className={dropdownCls}>
                    <li className="title">
                        <FormattedMessage {...messages.localeChoose} />
                    </li>
                    <li className={ruSelectLangClass}>
                        <a href="#" className={languageClassMap[Languages.RU]} onClick={this._onLangClick(Languages.RU)}>
                            {languageNameMap[Languages.RU]}
                        </a>
                    </li>
                    <li className={enSelectLangClass}>
                        <a href="#" className={languageClassMap[Languages.EN]} onClick={this._onLangClick(Languages.EN)}>
                            {languageNameMap[Languages.EN]}
                        </a>
                    </li>
                    {countryCode === 'KZ' && (
                        <li className={kkSelectLangClass}>
                            <a href="#" className={languageClassMap[Languages.KK]} onClick={this._onLangClick(Languages.KK)}>
                                {languageNameMap[Languages.KK]}
                            </a>
                        </li>
                    )}
                    {countryCode === 'UZ' && (
                        <li className={uzSelectLangClass}>
                            <a href="#" className={languageClassMap[Languages.UZ]} onClick={this._onLangClick(Languages.UZ)}>
                                {languageNameMap[Languages.UZ]}
                            </a>
                        </li>
                    )}
                </ul>
            </div>
        );
    }
}

function select(state, props) {
    const countryCode = state.application.get('countryCode');

    return {
        ...props,
        countryCode,
    };
}

export default connect(select)(Locale)



// WEBPACK FOOTER //
// ./js/shared/components/Locale.jsx